
import styles from './loader.module.css'
export function Loader({ size }) {
    return (
        <div className={`${styles.loader_holder} ${styles["loader_holder-30"]} `}>
            <div className={`${styles[`lds-dual-ring`]} ${styles[`lds-dual-ring-${size}`]}`}></div>
        </div>
    )
}
